// JsFromRoutes CacheKey 149de5de55f77daa71fe4b6991950722
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  list: definePathHelper('get', '/*path'),
}
